"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPremiumCalculationDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_activity_map_entity_1 = require("./opportunity-activity-map.entity");
const file_upload_entity_1 = require("./file-upload.entity");
let OpportunityPremiumCalculationDocumentMap = class OpportunityPremiumCalculationDocumentMap {
};
exports.OpportunityPremiumCalculationDocumentMap = OpportunityPremiumCalculationDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCalculationDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCalculationDocumentMap.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCalculationDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPremiumCalculationDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_activity_map_entity_1.OpportunityActivityMap, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_activity_id" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof opportunity_activity_map_entity_1.OpportunityActivityMap !== "undefined" && opportunity_activity_map_entity_1.OpportunityActivityMap) === "function" ? _a : Object)
], OpportunityPremiumCalculationDocumentMap.prototype, "opportunityActivity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => file_upload_entity_1.FileUpload, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "document_id" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof file_upload_entity_1.FileUpload !== "undefined" && file_upload_entity_1.FileUpload) === "function" ? _b : Object)
], OpportunityPremiumCalculationDocumentMap.prototype, "document", void 0);
exports.OpportunityPremiumCalculationDocumentMap = OpportunityPremiumCalculationDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_premium_calculation_document_map" })
], OpportunityPremiumCalculationDocumentMap);
